<template>
    <div>
      <div v-if="isGroup">
        <public-title>门店返利中心</public-title>
        <div class="load-area">
            <gcon-search @getSearchCon="getSearchCon" />
            <p v-if="total<=0">当前没有数据</p>
            <div v-else>
            <ul class="list-head"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
            <ul class="list-item" v-for="Itemize in lists" :key="Itemize.id">
                <li class="w-50 list-item-col">
                    <span class="text-link" @click="goStoreDetail(Itemize.id)">{{Itemize.title}}</span>
                </li>
                <li class="w-50 list-item-col">&yen;{{Itemize.all_money}}</li>
                <li class="w-50 list-item-col flex-column">
                    <span>&yen;{{Itemize.rebate_money}}</span>
                    <span class="text-link" v-show="Zero(Itemize.rebate_money)" @click="goForDetail(Itemize,'available')">去提现</span>
                </li>
                <li class="w-50 list-item-col flex-column">
                    <span>&yen;{{Itemize.withdraw}}</span>
                    <span class="text-link" v-show="Zero(Itemize.withdraw)" @click="goForDetail(Itemize,'done')">查看</span>
                </li>
                <li class="w-50 list-item-col flex-column">
                    <span>&yen;{{Itemize.rebate_freeze_money}}</span>
                    <span class="text-link" v-show="Zero(Itemize.rebate_freeze_money)" @click="goForDetail(Itemize,'frozen')">查看</span>
                </li>
                <li class="w-50 list-item-col" :class="[Itemize.verify === 1 ? 'text-success' : 'text-danger']">
                    {{Itemize.verify | formatVar('verifyType')}}
                </li>
                <li class="w-50 list-item-col">
                    {{Itemize.province_name}}-{{Itemize.city_name}}-{{Itemize.district_name}}
                </li>
                <li class="w-50 list-item-col-end">
                    <span class="text-link" @click="goForDetail(Itemize,'all')">查看</span>
                </li>
            </ul>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                :total="total" :current-page="Number(queryCon.page)"
                @current-change="v => {this.currentPage=v;this.$router.push({name:this.$route.name,query:{page:v}})}"/>
            </div>
        </div>
      </div>
      <rebate-index v-else/>
    </div>
</template>

<script>
  import { mapGetters,mapState} from 'vuex'
  import RebateIndex from './RebateIndex'
  import GconSearch from '../GconSearch'

  export default {
    name: 'RebateManage',
    components: { RebateIndex,GconSearch },
    data () {
        return {
            titleArr: ['门店名称','总计返利','可提返利','已提返利','冻结中','门店认证','所在地','操作'],
            lists: [],
            currentPage:1,
            total: 0,
            info: {}
        }
    },
    watch:{
      queryCon() { if (this.isGroup) this.getList() },
    },
    created () {
        if (this.isGroup) {
            if (this.queryCon.hasOwnProperty('page')) this.getList(this.$route.query.page)
            else this.getList()
        }
    },
    computed: {
        ...mapState(['StoreLists']),
        ...mapGetters(['storeInfo','isGroup']),
        queryCon() { return this.$route.query }
    },
    methods: {
        Zero (item) {
            if (Number(item) > 0) return true
            else return false
        },
        async getList (page) {
            let resData = await this.$axios.post('pc/Common/groupStoreRebate', {
                page: page ? page :this.currentPage, num: 10,...this.info 
            })
            if (resData.code === '00000') {
                this.lists = resData.data;
                this.total = resData.count
            }
        },
        goForDetail (item,tab) {
            this.$router.push({name:'RebateIncome',query:{storeId: item.id,tab,page:1,GST:item.title}})
        },
        goStoreDetail(id) {
            let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:this.storeInfo.type,id}});
            window.open(routeUrl.href, '_blank');
        },
        getSearchCon (info) {
            this.info=info;
            this.getList(1)
        }
    }
  }
</script>
